import api from '@/api';
import _ from 'lodash';
import { DateTime } from 'luxon';

export default {
    state: {
        emailResults: [],
        totalEmailResults: 0,
    },
    getters: {
        emailResults: state => state.emailResults,
        totalEmailResults: state => state.totalEmailResults,
    },
    mutations: {
        SET_EMAIL_RESULTS(state, emailResults) {
            state.emailResults = emailResults.map((email) => {
                return {
                    ...email,
                    created_at: DateTime.fromJSDate(new Date(email.created_at)).toLocaleString(DateTime.DATETIME_MED),
                };
            });
        },
        SET_TOTAL_EMAIL_RESULTS(state, totalEmailResults) {
            state.totalEmailResults = totalEmailResults;
        }
    },
    actions: {
        async getEmailResults({ commit }, { electionId, limit, skip, search }) {
            try {

                const response = await api.get(`/elections/${electionId}/emails?limit=${limit}&skip=${skip}&search=${search}`);

                const { data } = response;
                commit('SET_EMAIL_RESULTS', data.emailResults);
                commit('SET_TOTAL_EMAIL_RESULTS', data.total);
            } catch (error) {
                console.error(error);
            }
        }
    }
};
